// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminMarginChartController from "./admin_margin_chart_controller"
application.register("admin-margin-chart", AdminMarginChartController)

import AdminMarketPriceChartController from "./admin_market_price_chart_controller"
application.register("admin-market-price-chart", AdminMarketPriceChartController)

import AdminNavController from "./admin_nav_controller"
application.register("admin-nav", AdminNavController)

import AdminProfitChartController from "./admin_profit_chart_controller"
application.register("admin-profit-chart", AdminProfitChartController)

import CancelAccountController from "./cancel_account_controller"
application.register("cancel-account", CancelAccountController)

import CancellationReasonController from "./cancellation_reason_controller"
application.register("cancellation-reason", CancellationReasonController)

import FramepayController from "./framepay_controller"
application.register("framepay", FramepayController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import PriceChartController from "./price_chart_controller"
application.register("price-chart", PriceChartController)

import PickLabStrategyBuilderController from "./pick_lab_strategy_builder_controller"
application.register("pick-lab-strategy-builder", PickLabStrategyBuilderController)

import PickLabBacktestProgressController from "./pick_lab_backtest_progress_controller"
application.register("pick-lab-backtest-progress", PickLabBacktestProgressController)

import PurchaseOrderFormController from "./purchase_order_form_controller"
application.register("purchase-order-form", PurchaseOrderFormController)

import QuantitySelectionController from "./quantity_selection_controller"
application.register("quantity-selection", QuantitySelectionController)

import RoundupController from "./roundup_controller"
application.register("roundup", RoundupController)

import AddressModalController from "./address_modal_controller"
application.register("address-modal", AddressModalController)

import ShippingAddressController from "./shipping_address_controller"
application.register("shipping-address", ShippingAddressController)

import VerifyAddressController from "./verify_address_controller"
application.register("verify-address", VerifyAddressController)

import ShippingController from "./shipping_controller"
application.register("shipping", ShippingController)

import SubscriptionController from "./subscription_controller"
application.register("subscription", SubscriptionController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)

import UpsellController from "./upsell_controller"
application.register("upsell", UpsellController)

import UpsellVariantController from "./upsell_variant_controller"
application.register("upsell-variant", UpsellVariantController)

import HeaderDropdownController from "./header_dropdown_controller"
application.register("header-dropdown", HeaderDropdownController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ZeroBudgetController from "./zero_budget_controller"
application.register("zero-budget", ZeroBudgetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
